const DOCUMENT_TYPE = "api/residuos/documentType";
const PHONE_TYPE = "api/residuos/phoneType";
const ECONOMIC_ACTIVITY = "api/residuos/economicActivity";
const MEASUREMENT_UNIT = "api/residuos/unidadMedida";
const WASTE = "api/residuos/TipoResiduo/GetWaste";
const TYPE_WASTE = "api/residuos/TipoResiduo";
const EXHIBIT_TYPE = "api/residuos/ExhibitType";
const GENERATOR = "api/residuos/Generator";
const EXHIBIT_FILE = "api/residuos/exhibit/createFile";
const GUIDEFILE = "api/residuos/guideline";

export {
  DOCUMENT_TYPE,
  PHONE_TYPE,
  ECONOMIC_ACTIVITY,
  MEASUREMENT_UNIT,
  WASTE,
  TYPE_WASTE,
  EXHIBIT_FILE,
  EXHIBIT_TYPE,
  GENERATOR,
  GUIDEFILE
};
